import * as React from "react";
const SvgFiRrHatWizard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hat-wizard_svg__a)">
      <path
        fill="#062147"
        d="M23 22h-.15L17.124 7.772c-.104-.259-.1-.549.011-.804 0 0 2.595-3.808 2.616-3.848a2.14 2.14 0 0 0-.2-2.252c-.49-.657-1.295-.976-2.168-.82l-3.096.768A8.95 8.95 0 0 0 7.501 6.32L1.15 22H1a1 1 0 0 0 0 2h22a1 1 0 0 0 0-2M9.356 7.07c.908-2.26 2.881-3.86 5.345-4.298l3.095-.768c.023-.006.094-.017.151.06a.14.14 0 0 1 .029.125S15.39 5.983 15.37 6.024a3.05 3.05 0 0 0-.101 2.496l5.425 13.481H3.308zM17 17.951a.75.75 0 0 1-.459.705l-1.318.556-.526 1.316a.75.75 0 0 1-1.394 0l-.523-1.308-1.308-.523a.75.75 0 0 1 0-1.394l1.308-.523.523-1.308a.75.75 0 0 1 1.394 0l.52 1.301 1.299.492c.287.108.479.38.484.686m-6.08-4.345-.436-1.09-1.09-.436a.626.626 0 0 1 0-1.16l1.09-.436.436-1.09a.626.626 0 0 1 1.16 0l.433 1.084 1.082.41a.625.625 0 0 1 .022 1.16l-1.099.463-.439 1.097a.626.626 0 0 1-1.16 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hat-wizard_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHatWizard;
